import React, { useEffect } from 'react'
import { Input, Button, Dropdown, Icon } from 'semantic-ui-react'
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import './tp.css'

import CountryDropDown from "../reusable/CountryDropDownById";
import { decryptData } from '../reusable/cryptoUtil';

const axios = require('axios');
let domainList = [];

// Domain lock (email entered as prefix + fixed suffix) applies only to these
// domains. Every other GSI batch keeps normal, free-form email entry.
const LOCKED_DOMAINS = ['tcs.com'];

const Third_party = (props) => {
    const urlParams = new URLSearchParams(window.location.search);

    const [loading, set_loading] = React.useState(false)
    const [name, set_name] = React.useState('')
    const [email, set_email] = React.useState('')
    const [trainer_name, set_traner_name] = React.useState('')

    const [training_date, set_training_date] = React.useState('')

    const [emp_data, set_emp_data] = React.useState([])

    const [header, set_header] = React.useState('Attendance Detail')
    const [batch_id, set_batch_id] = React.useState(0)
    const [submitted, set_submitted] = React.useState(false)

    const [countryId, set_CountryId] = React.useState(0);
    const [countryname, set_CountryName] = React.useState("");
    const [corporate_domain, set_corporate_domain] = React.useState('');
    const [pax_list, set_pax_list] = React.useState([]);
    const [selected_pax, set_selected_pax] = React.useState(null);
    const validateEmail = (val) => {
        const regex = /^(?=.*[A-Za-z])[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/;
        return regex.test(val) && !/\.{2,}/.test(val);
    };

    useEffect(() => {
        set_loading(true);
        let assignment_ID;
        if (urlParams.has("type") || urlParams.has("Type")) {
            let encrypted_assignmentID = urlParams.get("batch_header");
            if (encrypted_assignmentID) {
                assignment_ID = decryptData(encrypted_assignmentID);
            }
        }
        else {
            assignment_ID = urlParams.get("batch_header");
        }
        console.log(`Decrypted Assignment ID : ${assignment_ID}`);
        set_loading(false);
        const id = assignment_ID;
        if (id) {
            get_header(id);
            get_DomainList(id);
            get_corporate_domain(id);
            get_registered_pax(id);
        }
    }, []);

    async function get_corporate_domain(id) {
        let { data } = await axios.get('yusuf/get_batch_domain?id=' + id + '')
        if (data.length > 0 && data[0].Domain) {
            const domain = data[0].Domain.toString().trim().replace(/^@/, '')
            if (LOCKED_DOMAINS.indexOf(domain.toLowerCase()) !== -1) {
                set_corporate_domain(domain)
            }
        }
    }

    async function get_registered_pax(id) {
        let { data } = await axios.get('yusuf/get_registered_pax?id=' + id + '')
        if (data.length > 0) {
            set_pax_list(data)
        }
    }

    async function get_DomainList(id) {
        // if GSI batch then list will be compared
        let { data } = await axios.get('yusuf/get_domain_list?id=' + id + '')
        if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
                domainList.push(data[i]);
                //  console.log(domainList[i]);
            }
            //domainList[] = data;
        }
    }

    async function get_header(id) {
        let { data } = await axios.get('yusuf/get_header?id=' + id + '')
        if (data.length > 0) {
            //set_data_list(data)
            //alert(JSON.stringify() )
            set_header(data[0].batch_header)
            set_batch_id(data[0].id)
        }
    }




    async function submit() {
        //alert(name + '-' + email + '-' + trainer_name + '-' + training_date )
        // let { data } = await axios.get('yusuf/add_tp_batch?email=' + email + '&name=' + name + '&tn=' + trainer_name + '&sd=' + training_date + '&batch_header_id=' + batch_id + '')
        console.log(email);
        console.log(name);
        console.log(trainer_name);
        console.log(training_date);
        console.log(batch_id);
        console.log(countryId);
        //console.log(domainList[0]);
        var chkDomain = false;
        for (var i = 0; i < domainList.length; i++) {
            var res = email.split("@");



            console.log(res[0]);
            console.log(res[1]);
            if (res.length > 1) {
                if (res[1].toString().trim() == domainList[i]["DomainName"]) {

                    chkDomain = true;
                }
            }

            // below code showing error for @tcs as entry of @cs available
            // if (email.indexOf(domainList[i]["DomainName"]) !== -1) {
            //     console.log(domainList[i]["DomainName"]);

            //     //mean true
            //     chkDomain = true;
            // }
        }
        // console.log(chkDomain);
        if (chkDomain == true) {
            alert('Enter Official Email Id !!!!');
            return;
        }

        if (/^\d+@/.test(email)) {
            alert('Your email looks like it only has numbers before the @. Please recheck and enter your email address.');
            return;
        }

        if (!validateEmail(email)) {
            alert('Please enter valid email address');
            return;
        }

        if (name == "") {
            alert('Name Required !!! This name will be displayed on your Certificate.');
            return;
        }

        if (countryId == "") {
            alert('Country Required !!!!');
            return;
        }

        let { data } = await axios.get('yusuf/add_tp_batch?email=' + email + '&name=' + name + '&tn=' + trainer_name + '&sd=' + training_date + '&batch_header_id=' + batch_id + '&country_id=' + countryId + '')

        //alert(JSON.stringify(data))

        if (data[0].result == 'success') {
            set_submitted(true)
        }
        else {
            alert(data[0].result)
        }
    }

    return (
        <div className="tp-page">
            {!submitted ? (
                <div className="tp-card">
                    <div className="tp-badge">
                        <Icon name='graduation cap' />
                    </div>

                    <h1 className="tp-title">{header}</h1>
                    <p className="tp-subtitle">
                        Please share this information to receive your DMOC code and other relevant information.
                    </p>

                    {pax_list.length > 0 && (
                        <div className="tp-field">
                            <label className="tp-label">Already Registered?</label>
                            <div className="tp-control">
                                <Dropdown
                                    placeholder='Search your name or email'
                                    fluid search selection clearable
                                    selectOnBlur={false}
                                    selectOnNavigation={false}
                                    value={selected_pax}
                                    options={pax_list.map((p) => ({
                                        key: p.StdId,
                                        value: p.StdId,
                                        text: p.Name + ' (' + p.Email + ')'
                                    }))}
                                    onChange={(e, { value }) => {
                                        set_selected_pax(value)
                                        const pax = pax_list.find((p) => p.StdId === value)
                                        if (pax) {
                                            set_name(pax.Name)
                                            set_email(pax.Email)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <div className="tp-field">
                        <label className="tp-label">Name <span className="tp-req">*</span></label>
                        <Input
                            className='tp-control'
                            icon='user outline'
                            iconPosition='left'
                            value={name}
                            onChange={(e) => {
                                set_name(e.target.value)
                            }}
                            placeholder='Enter your full name'
                            required />
                        <span className="tp-hint">This name will be displayed on your certificate.</span>
                    </div>

                    <div className="tp-field">
                        <label className="tp-label">Email <span className="tp-req">*</span></label>
                        {corporate_domain ? (
                            <Input
                                className='tp-control email-domain-input'
                                icon='mail outline'
                                iconPosition='left'
                                label={{ content: '@' + corporate_domain, className: 'domain-suffix-label' }}
                                labelPosition='right'
                                value={email.split('@')[0]}
                                onChange={(e) => {
                                    const prefix = e.target.value.split('@')[0]
                                    set_email(prefix + '@' + corporate_domain)
                                }}
                                placeholder='Enter email id (before @)' />
                        ) : (
                            <Input
                                className='tp-control'
                                icon='mail outline'
                                iconPosition='left'
                                type='email'
                                value={email}
                                onChange={(e) => {
                                    set_email(e.target.value)

                                }}
                                placeholder='Enter your official email' />
                        )}
                    </div>

                    <div className="tp-field">
                        <label className="tp-label">Country <span className="tp-req">*</span></label>
                        <div className="tp-control">
                            <CountryDropDown
                                scrolling
                                passChildData={(countryname, countryId) => {
                                    set_CountryId(countryId);
                                    set_CountryName(countryname);
                                }}
                            />
                        </div>
                    </div>

                    <div className="tp-field">
                        <label className="tp-label">Trainer Name</label>
                        <Input
                            className='tp-control'
                            icon='user circle outline'
                            iconPosition='left'
                            onChange={(e) => {
                                set_traner_name(e.target.value)

                            }}
                            placeholder='Trainer Name' />
                    </div>

                    <div className="tp-field">
                        <label className="tp-label">Training Date</label>
                        <div className="tp-control tp-datepicker">
                            <SemanticDatepicker disabled iconPosition="left" className="wid" placeholder={new Date()} format="DD-MMM-YYYY" onChange={(e, v) => {
                                set_training_date(v.value)
                            }} />
                        </div>
                    </div>

                    <Button
                        className='tp-submit'
                        fluid
                        loading={loading}
                        disabled={loading}
                        onClick={() => {
                            submit()
                        }}>
                        Submit
                    </Button>
                </div>
            ) : (
                <div className="tp-card">
                    <div className="tp-badge tp-badge-success">
                        <Icon name='check' />
                    </div>
                    <h1 className="tp-title">Thank You !</h1>
                    <p className="tp-subtitle" style={{ marginBottom: 0 }}>
                        Your data saved succesfully. Want to try your IT skill? Try{' '}
                        <span className="tp-link" onClick={() => { window.location.href = 'https://www.qubits42.com/' }}>QUBITS42</span>
                    </p>
                </div>
            )}
        </div>
    )
}



export default Third_party
